import i18n from '@/locales/i18n'
import { ADMIN_ORDERS_ROUTES } from '@/router/routes'
import type { RouteType } from '@rfc/rfc-components-library/types'

export const ADMIN_ORDERS_LIST_ROUTE_NAME = 'adminOrdersList'
export const ADMIN_ORDERS_DETAIL_ROUTE_NAME = 'adminOrdersDetail'

const routes: RouteType[] = [
    {
        path: ADMIN_ORDERS_ROUTES.baseUrl,
        name: ADMIN_ORDERS_LIST_ROUTE_NAME,
        component: () => import('@/views/AdminView/AdminOrdersView/AdminOrdersView.vue'),
        meta: {
            title: i18n.global.t('menu.adminOrders'),
            authRequired: true
        }
    },
    {
        path: ADMIN_ORDERS_ROUTES.detailUrl,
        name: ADMIN_ORDERS_DETAIL_ROUTE_NAME,
        component: () => import('@/views/OrdersView/OrderDetailView.vue'),
        meta: {
            title: i18n.global.t('menu.adminOrders'),
            authRequired: true
        }
    }
]

export default routes
